import { PdfDocumentProxy } from '../types';
import { loadPdfJs } from './pdfjsLoader';

/**
 * Load a PDF document from a URL
 * @param fileUrl - URL to the PDF file (can be remote URL or blob URL)
 * @returns Promise with PDF document proxy
 */
export const loadPdfDocument = async (fileUrl: string): Promise<PdfDocumentProxy> => {
  const pdfjsLib = await loadPdfJs();
  const loadingTask = pdfjsLib.getDocument({
    url: fileUrl,
    disableFontFace: false,
    useSystemFonts: false,
    standardFontDataUrl: '',
  });
  return loadingTask.promise;
};

/**
 * Load a PDF document from a File object
 * @param file - The PDF file to load
 * @returns Promise with PDF document proxy
 */
export const loadPdfFromFile = async (file: File): Promise<PdfDocumentProxy> => {
  const pdfjsLib = await loadPdfJs();
  const arrayBuffer = await file.arrayBuffer();
  const uint8Array = new Uint8Array(arrayBuffer);
  const loadingTask = pdfjsLib.getDocument(uint8Array as any);
  return loadingTask.promise;
};

/**
 * Create a temporary blob URL from a File object for preview
 * Remember to revoke the URL when done: URL.revokeObjectURL(url)
 * @param file - The PDF file
 * @returns Blob URL
 */
export const createPdfBlobUrl = (file: File): string => {
  return URL.createObjectURL(file);
};
